import React from "react";
import { Link } from "react-router-dom";
import { Network } from "lucide-react";

/** LLM Keys → pointer to the network-wide credential sharing page. */
export function SharedNetworkCard() {
    return (
        <div className="bg-[#0a0a0a] border border-white/10 rounded-md p-6" data-testid="shared-network-card">
            <div className="flex items-center gap-2 mb-1">
                <Network className="w-4 h-4 text-[#7C3AED]" strokeWidth={1.5} />
                <div className="font-display text-lg tracking-tight">Shared LLM providers across the network</div>
            </div>
            <p className="text-xs text-white/50 mb-3">The keys saved here can serve the whole Radar Sync network — and this environment can run AI features on credentials held elsewhere — without any key leaving its owner. Owner consent, routing priorities, budgets, data-residency rules and consumption live on their own page.</p>
            <Link to="/settings/shared-llm" className="inline-flex items-center gap-1.5 rounded border border-white/10 px-3 py-1.5 text-xs text-white/80 hover:bg-white/5" data-testid="shared-network-link">Open Shared LLM Providers →</Link>
        </div>
    );
}
